import { isOffline } from '@/global/utils';
import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';
import Component from './page';

Vue.use(Router);
const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: '/',
    component: Component.Index,
    meta: {
      label: 'all'
    },
    redirect: '/index',
    children: [
      {
        path: 'trainDetail',
        name: 'trainDetail',
        component: Component.TrainDetail,
      },
      {
        path: '/index',
        name: 'index',
        component: Component.Home,
        meta: {
          label: '龙猫学院'
        }
      },
      {
        path: '/top',
        name: 'top',
        component: Component.TopAmount,
        meta: {
          label: '荣誉榜'
        }
      },
      {
        path: '/publicnotice',
        name: 'notice',
        component: Component.PublicNotice,
        meta: {
          label: '龙猫公告'
        }
      },
      {
        path: '/task',
        name: 'task',
        component: Component.Layout,
        meta: {
          label: '任务大厅'
        },
        redirect: '/task/allpro',
        children: [
          {
            path: 'judge',
            name: 'judge',
            component: Component.Judge,
            meta: {
              label: '快判任务',
              icon: 'iconfont icon-kuaipanrenwu-moren',
              keepAlive: true
            },
          },
          // {
          //   path: 'trainNew',
          //   name: 'trainNew',
          //   component: Component.TrainNew,
          //   meta: {
          //     label: '培训任务',
          //     icon: 'iconfont icon-kuaipanrenwu-feixuanzhong',
          //     keepAlive: true
          //   },
          // },
          {
            path: 'allpro',
            name: 'allpro',
            component: Component.AllPro,
            meta: {
              label: '所有项目',
              icon: 'iconfont icon-suoyouxiangmu',
              keepAlive: true
            },
          },
          {
            path: 'mypro',
            name: 'mypro',
            component: Component.MyPro,
            meta: {
              label: '我参与的项目',
              icon: 'iconfont icon-wocanyude',
              keepAlive: true
            },
          },
          {
            path: 'search',
            name: 'search',
            component: Component.Search,
            // meta: {
            //   label: '搜索任务',
            //   icon: 'iconfont icon-sousuorenwu-moren',
            //   keepAlive: true
            // },
          },
          {
            path: 'project/detail/:id',
            name: 'project',
            component: Component.ProDetail,
          },
          {
            path: ':page/detail/:id',
            name: 'detail',
            component: Component.Detail,
          },
          {
            path: ':page/checkuser/:id',
            name: 'checkuser',
            component: Component.Check,
          },
          {
            path: ':page/inspect/:id',
            name: 'inspect',
            component: Component.Inspect,
          },
          {
            path: 'judge/check/:id',
            name: 'judgecheck',
            component: Component.JudgeCheck,
          },
          {
            path: ':page/examine/:id',
            name: 'examine',
            component: Component.Examine,
          },
          {
            path: 'judge/lib/:id',
            name: 'lib',
            component: Component.JudgeLib,
          },
          {
            path: ':page/check/first/:id',
            name: 'checkfirst',
            component: Component.CheckFirst,
          },
          {
            path: 'train/check/:id',
            name: 'traincheck',
            component: Component.TrainCheck,
          },
          {
            path: 'pkgList/info',
            name: 'toPkgList',
            component: Component.ToPkgList,
          },
          {
            path: ':page/examine/user/:id/pkg/:pkg_id',
            name: 'examineUser',
            component: Component.ExamineUser,
          },
          {
            path: ':page/examine/detail/:id/user/:puid/pkg/:pkg_id',
            name: 'examineDetail',
            component: Component.ExamineDetail,
          },
          {
            path: ':page/inspect/user/:id',
            name: 'inspectUser',
            component: Component.InspectUser,
          },
          {
            path: ':page/inspect/detail/:id/user/:puid',
            name: 'inspectDetail',
            component: Component.InspectDetail,
          },
          {
            path: ':page/inspect/user/:id/package/:pkg_id',
            name: 'inspectPackage',
            component: Component.InspectPackage,
          },
        ],
      },
      {
        path: '/train',
        name: 'train',
        component: Component.Layout,
        redirect: '/train/1/0',
        meta: {
          label: '培训大厅'
        },
        children: [
          {
            path: ':type/:subType',
            name: 'trainPage',
            component: Component.TrainV3,
            meta: {
              keepAlive: true
            }
          },
        ]
      },
      {
        path: '/mine',
        name: 'mine',
        component: Component.Layout,
        redirect: '/mine/message',
        meta: {
          label: '个人中心'
        },
        children: [
          {
            path: 'message',
            name: 'message',
            component: Component.Message,
            meta: {
              label: '消息中心',
              icon: 'iconfont icon-xiaoxizhongxin-moren',
            },
          },
          {
            path: 'account',
            name: 'account',
            component: Component.Account,
            meta: {
              label: '我的账户',
              icon: 'iconfont icon-zhanghaoxinxi-moren',
            },
          },

          {
            path: 'myteamdetail',
            name: 'myteamdetail',
            component: Component.MyTeamDetail,
            meta: {
              label: '我的团队',
              icon: 'iconfont icon-wodetuandui-moren',
              from: 'team'
            },
          },
          {
            path: 'drawcash',
            name: 'drawcash',
            component: Component.Drawcash,
            meta: {
              label: '余额提现',
              icon: 'iconfont icon-yuetixian',
            },
          },
          {
            path: 'income',
            name: 'income',
            component: Component.Income,
            meta: {
              label: '账目明细',
              icon: 'iconfont icon-zhangmumingxi',
            },
          },
          {
            path: 'star',
            name: 'star',
            component: Component.ExpDetail,
            meta: {
              label: '经验值明细',
              icon: 'iconfont icon-jingyanzhimingxi',
            },
          },
          {
            path: 'taskdetail',
            name: 'taskdetail',
            component: Component.TaskDetail,
            meta: {
              label: '任务明细',
              icon: 'iconfont icon-renwumingxi',
            },
          },
          {
            path: 'activity',
            name: 'activity',
            component: Component.Activity,
            meta: {
              label: '热门活动',
              icon: 'iconfont icon-remen1',
            },
          },

          {
            path: 'user',
            name: 'user',
            component: Component.User,
            // redirect: '/mine/user/drawcash',
            meta: {
              label: '其他',
              icon: 'iconfont icon-qita',
            },
            children: [

              {
                path: 'supplier',
                name: 'supplier',
                component: Component.Supplier,
                meta: {
                  label: '供应商认证',
                },
              }
            ],
          },
        ],
      },
      {
        path: '/login',
        name: 'login',
        component: Component.Login,
      },
      {
        path: '/bind/:page',
        name: 'bind',
        component: Component.Bind,
      },
      {
        path: '/join',
        name: 'join',
        component: Component.Join,
      },
      {
        path: '/team_guide',
        name: 'team_guide',
        component: Component.TeamGuide,
      },
    ],
  },
  {
    path: '/docs/showIncome',
    name: 'docs',
    component: Component.ShowIncome,
  },
  {
    path: '*',
    redirect: '/',
  },
]


if (isOffline() && process.env.VUE_APP_PAGE_HIDE) {
  ; (function (routes: Array<RouteConfig>) {
    const removeRouteList: Array<string> = JSON.parse(process.env.VUE_APP_PAGE_HIDE)
    if (Array.isArray(removeRouteList)) {
      ; (function removeRoutes(routes: Array<RouteConfig>) {
        for (let i = 0; i < routes.length; i++) {
          if (routes[i].meta && routes[i].meta.label) {
            if (removeRouteList.includes(routes[i].meta.label)) {
              routes.splice(i, 1)
              i--
              continue
            }
            if (Array.isArray(routes[i].children)) {
              removeRoutes(routes[i].children)
            }
          }
        }
      })(routes)
      // 去除龙猫学院后，将任务大厅设置为首页
      if (removeRouteList.includes('龙猫学院')) {
        for (let i = 0; i < routes.length; i++) {
          if (routes[i].path === '/' || routes[i].path === '*') {
            routes[i].redirect = '/task'
          }
        }
      }
      if (removeRouteList.includes('消息中心')) {
        routes[0].children.forEach(item => {
          if (item.name === 'mine') {
            item.redirect = `${item.path}/${item.children[0].path}`
          }
        })
      }
    }
  })(routes)
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
